import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/desc-img.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-9b8ecfa4")

_pushScopeId("data-v-9b8ecfa4")
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "banner" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "desc" }, [
  /*#__PURE__*/_createVNode("div", null, [
    /*#__PURE__*/_createVNode("h3", { class: "about-title left" }, [
      /*#__PURE__*/_createTextVNode("关于小芒"),
      /*#__PURE__*/_createVNode("span", { class: "title-bg" }, "ABOUT XIAO MANG")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "desc-content bolder" }, [
      /*#__PURE__*/_createTextVNode(" 湖南快乐阳光互动娱乐传媒有限公司的 "),
      /*#__PURE__*/_createVNode("span", { class: "underline" }, "小芒APP是集合社交、内容、电商于一体的新潮国货内容电商平台。")
    ]),
    /*#__PURE__*/_createVNode("p", { class: "desc-content" }, " 小芒的平台责任是从中国制造到中国创造，让国潮成为潮流消费习惯。小芒致力于将中国文化元素和中国品牌全面渗透到中国青年的生活形成潮流，并伴随中国品牌一起走向世界。芒果TV向小芒输送优质视频内容及丰富的娱乐资源，形成小芒直播＋优质精选内容＋丰富优质商品的娱乐电商生态体系，定位为业内最具青春号召力，最具购买场景，最富综艺特性的电商平台，走一条边娱乐边社交边购物的电商平台之路。 "),
    /*#__PURE__*/_createVNode("p", { class: "desc-content" }, " 依托于芒果TV的内容优势，小芒将在内容领域全力打造，并建立自己的领先优势。目前，芒果TV运营商电视业务现覆盖31个省级行政区域，覆盖用户达1.48亿，在运营商大屏市场打造极具特色的“芒果TV专区”；在湖南省内，与电信，联通，移动展开合作，在深耕用户运营，强化全平台新媒体业务优势的同时，大力推动IPTV产业的技术革新和业务形态的创新研发。 "),
    /*#__PURE__*/_createVNode("p", { class: "desc-content bolder" }, "我们全新出发，致力于为广大用户创造优质视频社区，"),
    /*#__PURE__*/_createVNode("span", { class: "desc-content bolder underline" }, " 精选全国物美价廉的新潮国货，让用户娱乐无极限，购物爽无边。 ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "desc-img" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ])
], -1)
const _hoisted_4 = { class: "brand" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h3", { class: "about-title" }, "合作品牌", -1)
const _hoisted_6 = { class: "contact" }
const _hoisted_7 = /*#__PURE__*/_createVNode("h3", { class: "about-title" }, "联系我们", -1)
const _hoisted_8 = {
  class: "contact-map",
  ref: "map$"
}
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"addr\" data-v-9b8ecfa4><div data-v-9b8ecfa4><p class=\"addr-item\" data-v-9b8ecfa4><span class=\"addr-item-title\" data-v-9b8ecfa4>招商邮箱：</span> zhaoshang@mgtv.com </p><p class=\"addr-item\" data-v-9b8ecfa4><span class=\"addr-item-title\" data-v-9b8ecfa4>招聘邮箱：</span> hr@mgtv.com </p><p class=\"addr-item\" data-v-9b8ecfa4><span class=\"addr-item-title\" data-v-9b8ecfa4>服务热线：</span> 400-9770-707 </p><p class=\"addr-item\" data-v-9b8ecfa4><span class=\"addr-item-title\" data-v-9b8ecfa4>办公地址：</span> 湖南省长沙市开福区广电路湖南广电大楼 </p></div><div class=\"qrcode\" data-v-9b8ecfa4><div class=\"qrcode-download\" data-v-9b8ecfa4>下载小芒APP</div><div class=\"qrcode-wx\" data-v-9b8ecfa4>关注微信小程序</div></div></div>", 1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_swiper, {
        class: "brand-swiper",
        autoplay: "",
        pagination: {
          clickable: true
        }
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(Math.ceil(_ctx.brandList.length / 15), (item) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, {
              class: "brand-swiper-slide",
              key: item
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.brandList.slice((item - 1) * 15, item * 15), (v, i) => {
                  return (_openBlock(), _createBlock("div", {
                    class: "brand-item",
                    key: i
                  }, [
                    _createVNode("img", {
                      src: v,
                      alt: ""
                    }, null, 8, ["src"])
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_6, [
      _hoisted_7,
      _createVNode("div", _hoisted_8, null, 512),
      _hoisted_9
    ])
  ]))
})